
import { useState,useEffect } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from "react-router-dom";
import submittedgradesapi from '../api/submittedgrades';
import loginapi from '../api/login';
import { APISERVERURL } from '../APIServerURL';



function AttendanceSheet({accessToken,setAccessToken,setRefreshFailed,sessions=[]}) {
    const navigate = useNavigate();
  const [code,setCode]=useState('');
  const [students,setStudents]=useState([]);
  const [message,setMessage]=useState('');
  const [selectedCollege,setSelectedCollege]=useState('');
  const [selectedCollegeName,setSelectedCollegeName]=useState('');
  
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  const [printDate,setPrintDate]=useState('');
   // const session='2025-DECEMBER';
    const [session,setSession]=useState("");

 
  const colleges=[
  {
        code:560,
        title:"Anundoram Borooah Academy"
    },
    {
        code:106,
        title:"Baosi Banikanta Kakati College (BBK) , Nagaon"
    },
    {
    code:105,
    title:"Barnagar College, Sorbhog"
  },
  {
      code:701,
      title:"Bhattadev College, Bajali"
      },
  {
    code:102,
    title:"B. H. College, Barpeta"
  },
    {
        code:101,
        title:"Madhab Choudhury College (M.C. College), Barpeta"
    },{
    code:103,
    title:"Nabajyoti college, Kalgachia"
    },

];
const sessionChanged = async (e) => {
    const tsession = e.target.value;
    setSession(tsession);
  
  };
  function onCollegeChange(e)
  {
    setSelectedCollege(e.target.value);
    const college = colleges.find((col) => col.code == e.target.value); 
    //alert(JSON.stringify(college));alert(JSON.stringify(e.target.value));
    if(college && college.title)
    {
      setSelectedCollegeName(college.title||'');

    }
    else{

      setSelectedCollegeName('');
    }
  }
  function getDDLColleges()
  {    
    return (<select className="borderLess" value={selectedCollege} id='ddlProgram'
      onChange={(e)=>{onCollegeChange(e)}}
            >
      <option key={'none'} value={''}>
            {'SELECT ONE'}
      </option>
      {colleges.map((college) => (
          <option key={college.code} value={college.code}>
            {college.title}
          </option>
        ))}
      </select>);
  }


  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }
const getPdf=async ()=>{
      try{
        //alert(img+" "+postId);
        //post request to deletePhoto wit {id,fileName}
        //setIsAppLoaded(false);
        const response= await submittedgradesapi.post('/downloadEnrolledStudentsInACourse',{code:code,college:selectedCollege,printDate,session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          //alert(JSON.stringify(x['data']['accessToken']));
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          //console.log(`ne at ${nat}`);
          //console.log(`Second at:${accessToken}`);
          //alert('ok');
          try{       
            const response= await submittedgradesapi.post('/downloadEnrolledStudentsInACourse',{code:code,college:selectedCollege,printDate,session},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(JSON.stringify(response.data));
            downloadFile(response.data);
          }
          catch(err)
          {
            alert('unusual error newposts.js');
            setIsAppLoaded(true);
            //alert(JSON.stringify(err));
            //navigate('/');
          }
        }
        catch(err)
        {
          alert(JSON.stringify(err));
          //setIsAppLoaded(true);
          //setError(JSON.stringify(err));
          //navigate('/');
        }

      }
      finally{
        //setIsAppLoaded(true);
      }
    }

    
  const StudentList = ({ students }) => {
    return (
      <div style={{ margin: '20px' }}>
      <div className="div flex flex-col justify-center items-center gap-2">
        <label>Select exam date to print on attendance sheet:</label>
        <input value={printDate} onChange={(e)=>setPrintDate(e.target.value)} className="border-b border-gray-200 hover:border-red-500 focus:border-green-500 p-1 outline-none" type="date"></input>
      </div>

        <h2>Student List</h2><button className="link-button" onClick={(e)=>getPdf(e)}>DOWNLOAD</button>
        <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f2f2f2' }}>
              <th style={{ padding: '10px' }}>Sl. No</th>
              <th style={{ padding: '10px' }}>Roll Number</th>
              <th style={{ padding: '10px' }}>Name</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student._id}>
                <td style={{ padding: '10px', textAlign: 'center' }}>{index + 1}</td>
                <td style={{ padding: '10px', textAlign: 'center' }}>{student.rollno}</td>
                <td style={{ padding: '10px' }}>{student.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const handleGoBack = () => {
    navigate(`/formfillupDetails`); 
  };

  const onTxtCodeChange=(e)=>{
    setStudents([]);
    setCode(e.target.value);
    setMessage('');
  }
  const handleGo=async ()=>{
    if(selectedCollege==='' || code==='')
    {
      alert('Invalid Inpput!');
      return;
    }
    try{       
        //const response=await loginapi.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await submittedgradesapi.post('/getEnrolledStudentsInACourse',{code:code,college:selectedCollege,session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data)); 
        setStudents(response.data);setMessage('OK');
        //alert(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await loginapi.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await submittedgradesapi.post('/getEnrolledStudentsInACourse',{code:code,college:selectedCollege,session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify( response.data)); 
                        setStudents(response.data);setMessage('OK');
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      //alert('Student Not Found');
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }
    return (
      <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> ATTENDANCE SHEET</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
              
              <div className="flex flex-col items-center text-center mt-4">
            <p className="text-center">Select Exam session</p>
            <select
        value={session}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>

                <div className="inputGroup ">
                  <label className="marginTop" htmlFor="txtCode">Course Code:</label>
                  <input
                    type="text"
                    placeholder="Enter the course code"
                    className="borderLess"
                    id="txtCode"
                    required
                    value={code}
                    onChange={onTxtCodeChange}
                  />
                 
                </div>

                <div className="inputGroup ">
                <label className="marginTop"  htmlFor='ddlProgram'>SELECT YOUR COLLEGE:</label>
                {  getDDLColleges()}
                </div>

                <div className="actionBar marginTop">        
                  <button className="btn btn-success loginButton" onClick={handleGo}>GO</button>
                </div>

               {
               students && students.length>0 && 
               <div>
                  <StudentList
                  students={students}
                  ></StudentList>
               </div>
               }
               {
               (!students || students.length===0) && message!=='' &&
               <div>
                <p>NO STUDENTS TO DISPLAY</p>
               </div>
               }
            </div>

        </div>
      </main>
    )
  }
  
  export default AttendanceSheet